import React, { useMemo } from 'react';
import Firebase, { FirebaseContext } from './firebase/';

import MainRouter from './MainRouter';

const RenderFirebase = (props) => {
    const firebaseKey = props.config && (
      props.config.projectId || props.config.apiKey || props.config.authDomain
    );
    const firebaseInstance = useMemo(
      () => new Firebase({config: props.config}),
      [props.config]
    );

    return(
      <FirebaseContext.Provider key={firebaseKey} value={firebaseInstance}>
          <MainRouter/>
      </FirebaseContext.Provider>
    );
}

export default RenderFirebase;
